import React from 'react'
import RenderTextFieldRedux from './RenderTextFieldRedux';
import { Grid, Icon, Fab } from '@material-ui/core';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { Field, reduxForm } from 'redux-form';

const validate = values => {
    const error  = {}
    return error
}

const BeneficiaryFilterExternalForm = props => {

    const { handleSubmit, handleChangeFilter } = props;

    return (
            <Grid container spacing={3}>
                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                    <Field
                        name="filtro"
                        id="filtro"
                        required
                        component={ RenderTextFieldRedux }
                        label="Buscar..."
                        type="text"
                        fullWidth
                        onChange={handleChangeFilter}
                    />
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                    <Fab color="primary" style= {{ backgroundColor:'#00a0af'}} aria-label="add" onClick = { handleSubmit } >
                        <Icon>search</Icon>
                    </Fab>

                </Grid>
            </Grid>
        
    )
}

const BeneficiaryFilterExternalFormRedux = reduxForm(
    {
        form: 'BeneficiaryFilterExternalForm',
        validate
    }
)(BeneficiaryFilterExternalForm)
export default setPropsAsInitial(BeneficiaryFilterExternalFormRedux)

